// src/components/admin/BooleanToggleButton.tsx
import React from 'react';

interface BooleanToggleButtonProps {
  label: React.ReactNode;
  value: boolean;
  onToggle: (newValue: boolean) => void;
  height?: number;
}

export const BooleanToggleButton: React.FC<BooleanToggleButtonProps> = ({
  label,
  value,
  onToggle,
  height = 33,
}) => {
  const displayText = value ? '公開' : '非公開';
  return (
    <div className="mb-6 border-b border-gray-400">
      <div className="flex items-center my-3">
        <label className="font-bold w-1/6">{label}</label>
        <div className="w-3/4">
          <button
            onClick={() => onToggle(!value)}
            className="px-4 py-2 rounded border bg-white text-black border-gray-300 transition-transform duration-150"
            style={{ minHeight: `${height}px` }}
          >
            {displayText}
          </button>
        </div>
      </div>
    </div>
  );
};
